import { useEffect } from 'react';

import { useAppDispatch } from '@shared/hooks/redux';
import { getCookieValue } from '@shared/utils/getCookieValue';
import { setAuth } from '@store/Common/commonSlice';

import type { Nullable } from '@shared/types/base-custom.type';
import type { AppDispatch } from '@store/store';

const AUTH_CONSTANTS = {
  LOCAL_STORAGE_TOKEN_KEY: 'token',
  COOKIE_AUTH_TOKEN_KEY: 'auth_token',
};

const AUTH = {
  getTokenFromLocalStorage: (): Nullable<string> =>
    localStorage.getItem(AUTH_CONSTANTS.LOCAL_STORAGE_TOKEN_KEY),
  getAuthTokenFromCookies: (): Nullable<string> => getCookieValue(AUTH_CONSTANTS.COOKIE_AUTH_TOKEN_KEY),

  checkAuthentication: (dispatch: AppDispatch) => {
    const token = AUTH.getTokenFromLocalStorage();
    const authToken = AUTH.getAuthTokenFromCookies();
    if (token || authToken) {
      dispatch(setAuth(true));
    }
  },
};

export const useAuthCheck = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    AUTH.checkAuthentication(dispatch);
  }, [dispatch]);
};
